import { render } from "./Introduction.vue?vue&type=template&id=1e44b76e"
import script from "./Introduction.vue?vue&type=script&lang=js"
export * from "./Introduction.vue?vue&type=script&lang=js"

import "./Introduction.vue?vue&type=style&index=0&id=1e44b76e&lang=css"
script.render = render

export default script